<template>
  <div>
    <div class="payments-upload">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="payments-upload__head">
            <h4 class="payments-upload__head__title">
              Carga masiva de promociones
            </h4>
          </div>
          <div class="payments-upload__body">
            <form action="">
              <div class="row mb-4">
                <div class="col-md-7">
                  <div class="form-group">
                    <label for="">Cargar Excel de pagos</label>
                    <input
                      class="form-control"
                      type="file"
                      @change="uploadFile($event)"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10">
                  <div class="payments-upload__body__loader">
                    <div v-if="this.flags.searching">
                      <i class="fas fa-circle-notch fa-spin d-block mb-1"></i>
                      Cargando operaciones...
                    </div>
                    <div v-if="this.flags.noPendingPayments">
                      No se encontraron pagos pendientes para las p&oacute;lizas
                      cargadas.
                    </div>
                  </div>
                  <table
                    class="table table-hover table-striped"
                    v-if="!flags.searching && operations.length > 0"
                  >
                    <thead>
                      <tr>
                        <th>N</th>
                        <th>P&oacute;liza</th>
                        <th>Prima gratis</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in operations"
                        v-bind:key="item.additionalContributionId"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          {{ item.policyNumber }}
                        </td>
                        <td>
                          {{ item.freeInstallment }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    class="form-group text-right mt-5"
                    v-if="operations.length > 0"
                  >
                    <button
                      type="button"
                      class="btn btn-main"
                      @click="registerPayments()"
                      :disabled="flags.loading"
                    >
                      <span v-if="!flags.loading">Registrar promociones</span>
                      <span v-if="flags.loading"
                        >Registrando promociones ...</span
                      >
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-error"
      ok-only
      ok-title="Entiendo"
      centered
      size="sm"
      modal-class="modal-error"
      ref="modal-error"
    >
      <div class="modal-error__head">
        <img :src="require('@/assets/images/app/alert.svg')" alt="" />
        <h3>Ups!</h3>
      </div>
      <div class="modal-error__head">
        <p>
          {{ errors.message }}
        </p>
      </div>
    </b-modal>

    <!-- <b-modal id="modal-success" ok-only ok-title="Entiendo" centered size="sm" modal-class="modal-success"
            ref="modal-success">
            <div class="modal-success__head pt-2">
                <i class="fas fa-check-circle fa-3x"></i>
                <h3>Registro de promociones exitoso</h3>
            </div>
            <div class="modal-success__head">
                <p>
                    Se han registrado los pagos del mes de las p&oacute;lizas cargadas.
                </p>
                <p class="text-center mt-3">
                    <a :href="basePath + '/operations'">Ir a mis operaciones</a>
                </p>
            </div>
        </b-modal> -->

    <b-modal
      id="modal-success"
      ok-only
      ok-title="Entiendo"
      centered
      modal-class="modal-success"
      ref="modal-success"
    >
      <div class="modal-success__header">
        <div class="modal-success__header__message">
          <span>Registro de promociones exitoso</span>
        </div>
      </div>

      <div class="modal-success__head">
        <div class="modal-success__head__content" style="margin-top: 20px">
          <span>Se han registrado las primas devueltas de las p&oacute;lizas cargadas.</span>
        </div>
        <div class="modal-success__head__btn">
          <button
            type="button"
            class="accept"
            @click="closeModal('modal-success')"
          >
            Ir a mis p&oacute;lizas
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>



<script lang="ts">
import { BButton, BModal, VBModal, BCardText } from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import es from "vuejs-datepicker/dist/locale/translations/es";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import * as XLSX from "xlsx"; //npm install xlsx
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import moment from "moment";
import { init } from "echarts/lib/echarts";
import { environment } from "../../../environment/environment";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    Datepicker,
    BCardText,
    VueSlider,
    BModal,
  },
  data() {
    return {
      apiUrl: environment.api,
      basePath: window["basePath"],
      operations: [],
      flags: {
        loading: false,
        searching: false,
        noPendingPayments: false,
      },
      es: es,
      errors: {
        message: "",
      },
      data: [],
      model: [],
    };
  },
  validations: function () {
    return {};
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    init() {},
    uploadFile(evt) {
      const target = evt.target;
      this.data = [];
      this.model = [];
      this.uploadingExcel = true;
      if (target.files.length !== 1)
        throw new Error("Cannot use multiple files");
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        this.data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        for (var i = 0; i < this.data[0].length; i++) {
          this.model.push({
            value: this.data[0][i],
            label: this.data[0][i],
          });
        }

        this.data = this.data.filter((el, i) => {
          return i > 0;
        });

        this.buildDataTable();
      };
      reader.readAsBinaryString(target.files[0]);
    },
    buildDataTable() {
      var model = [];

      model = this.data.map((el) => {
        return {
          policyNumber: `0${el[0]}`,
          freeInstallment: el[1],
        };
      });

      this.operations = model;
      // this.loadOperations();
    },
    async loadOperations() {
      this.flags.searching = true;

      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      var result = await axios.post(
        `${this.apiUrl}policies/get-monthly-payments`,
        this.model,
        headers
      );

      try {
        if (result.data) {
          let data = result.data;

          data = data.map((el) => {
            el.loading = false;
            return el;
          });
          this.operations = data;
          this.flags.searching = false;

          if (this.operations.length === 0) this.flags.noPendingPayments = true;
        }
      } catch (error) {}
      this.flags.searching = false;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async registerPayments() {
      this.flags.loading = true;

      let model = this.operations;

      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      var result = await axios.post(
        `${this.apiUrl}policies/upload-promos`,
        {
          Promotions: model,
        },
        headers
      );

      try {
        if (result.data) {
          this.$refs["modal-success"].show();
          this.operations = [];

          this.flags.loading = false;
        }
      } catch (error) {
        this.flags.loading = false;
      }
    },
    closeModal(modal) {
      this.$refs[modal].hide();
      this.$router.push({
        name: "adminpolicies",
      });
    },
  },
});
</script>

<style lang="scss">
/**/
@import "../../../styles/abstracts/variables";
/**/

.payments-upload {
  &__head {
    margin: 30px 0px 30px 0px;

    &__title {
      font-weight: 500;
      font-size: 28px;
      color: #0855c4;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__body {
    &__load {
      color: $primaryBlue;
      text-align: center;
    }

    .row {
      .form-group {
        label {
          font-size: 14px;
          color: $primaryBlue;
          margin-bottom: 5px;
        }
        .form-control {
          height: 57px;
          font-size: 14px;
          border: 1px solid #c5c5c5;
          border-radius: 4px;
          border-width: 2px;
          padding: 1rem 2rem;
          background-color: #fff;
        }
      }
    }

    &__loader {
      display: flex;
      justify-content: center;
      color: $primaryBlue;
    }

    .table {
      thead {
        tr {
          th {
            vertical-align: top;
            text-transform: uppercase;
            font-size: 12px;
            letter-spacing: 0.5px;
            color: $primaryGray;
            padding: 0.72rem 2rem;
            border-bottom: 2px solid #ebe9f1;
            background-color: #f3f2f7;
          }
        }
      }

      tbody {
        tr {
          background-color: white;

          td {
            font-size: 14px;
            color: $primaryGray;
            border: none;
            padding: 0.72rem 2rem;
            vertical-align: middle;
            border-top: 1px solid #ebe9f1;

            .badge {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 11px;
              height: 25px;
              width: fit-content;
            }

            a {
              text-decoration: none;
              color: $primaryBlue;
            }

            .delete {
              display: flex;
              align-items: center;
              color: $primaryRed;
              background-color: transparent;
              border: none;

              span {
                display: block;
                padding-left: 10px;
              }
            }

            .badge-success {
              background-color: $green;
            }

            .badge-danger {
              background-color: $primaryRed;
            }

            .badge-purple {
              background-color: $primaryPurple;
            }
          }
        }

        tr:nth-child(even) {
          background-color: transparent;
        }
      }

      & > :not(caption) > * > * {
        box-shadow: none;
      }
    }

    &__table {
      &__actions {
        a {
          &:first-child {
            margin-right: 15px;
            color: $primaryBlue !important;
          }

          &:last-child {
            color: $primaryRed !important;
          }
        }
      }
    }
  }
}
</style>
